import { createFileRoute } from "@tanstack/react-router";
import { useAuth } from "../stores/auth";
import { useActiveCompany } from "../stores/active-company";
import { EntsoeTokenSection } from "../components/admin/entsoe";

export const Route = createFileRoute("/admin/entsoe")({
  component: AdminEntsoePage,
});

function AdminEntsoePage() {
  const user = useAuth((s) => s.user);
  const activeCompanyId = useActiveCompany((s) => s.activeCompanyId);
  if (!user) return null;
  return (
    <EntsoeTokenSection
      isGlobalAdmin={user.role === "global_admin"}
      activeCompanyId={user.role === "global_admin" ? activeCompanyId : user.companyId}
    />
  );
}
